import * as moment from 'moment';

/**
 * Values the card disclosure forms (case_form_CC_AUTH / _recurring) read back
 * to the debtor. They only exist in the payment page's reactive form, so they
 * are collected here and handed to CustomFormPage, which substitutes them
 * into the form definition before Form.io renders it.
 */
export interface CcAuthVariableSource {
  cardholderName?: string;
  cardNumber?: string;
  amount?: string | number;
  currencySymbol?: string;
  paymentDate?: string;
}

/**
 * Build the [[token]] map for the card disclosure form. company_name is
 * resolved server-side (get_config_var), so it is not produced here.
 */
export function buildCcAuthVariables(source: CcAuthVariableSource): { [key: string]: string } {
  return {
    cardholder_name: (source.cardholderName || '').trim(),
    // Never expose the full card number in the disclosure wording.
    card_last4: lastFour(source.cardNumber),
    payment_amount: formatAmount(source.amount, source.currencySymbol),
    payment_date: formatDate(source.paymentDate),
  };
}

function lastFour(cardNumber) {
  const digits = String(cardNumber || '').replace(/\D/g, '');
  return digits.slice(-4);
}

function formatAmount(amount, currencySymbol) {
  if (amount === null || amount === undefined || amount === '') {
    return '';
  }
  const numeric = parseFloat(String(amount).replace(/[^0-9.\-]/g, ''));
  if (isNaN(numeric)) {
    return '';
  }
  return (currencySymbol || '') + numeric.toFixed(2);
}

function formatDate(paymentDate) {
  const date = paymentDate ? moment(paymentDate) : moment();
  return date.isValid() ? date.format('MM/DD/YYYY') : '';
}
